import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { from } from 'rxjs';
import {State} from './ext-profils.reducers';
import {IResultAudit} from '@app/components/projects/ext-profils/store/ext-profils.actions';
import {TranslateService} from '@ngx-translate/core';
import {State as authState} from '@store/reducers/auth.reducers';
import {State as ProjectState} from '@store/reducers/projects.reducer';
import {AuthService} from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ExtIntegrityService {
  constructor(
    private translator: TranslateService,
    private authService: AuthService,
  ) {
  }

  hasWhiteSpace(s: string) {
    return s?.indexOf(' ') >= 0;
  }

  checkIntegrity(state: State, user: { authState: authState, projectState: ProjectState }): Observable<IResultAudit> {

    const promiseResult = ({state: State, user: {authState: authState, projectState: ProjectState}}) => {
      // filterExpression = [['age_range', 'contains', '40 - 49']];
      // console.log(filterExpression);

      return new Promise<IResultAudit>((resolve, reject) => {

        //
        // Si on est pas Godmode.... finalement on fait rien (il faudrait exclure les ext qui sont flagall car ça pose des problèmes quand ils
        // s'invalident et qu'ils passent en mode écriture :/
        //
        // console.log(user);
        if (!this.authService.isLogged()) {
          resolve({});
        }
        if (!user.authState.user?.context?.userAccess.includes('GOD_MODE')) {
          resolve({});
        }

        const result = {};

        const keyNamesForExt = [];
        const duplicatesKeyNameForExt = [];

        const keyNamesForParams = [];
        const duplicatesKeyNameForParams = [];

        state.extProfilsList.forEach((aExt) => {
          result[aExt.uuid] = [];

          // KeyNames avec des espaces
          if (this.hasWhiteSpace(aExt.keyName)) {
            result[aExt.uuid].push({
              severity: 'red',
              where: 'keyName',
              label: this.translator.instant('Contient un espace'),
              value: aExt.keyName,
              uuid: aExt.uuid,
            });
          }

          // KeyNames en double ?
          if (keyNamesForExt.includes(aExt.keyName)) {
            duplicatesKeyNameForExt.push(aExt.keyName);
            result[aExt.uuid].push({
              severity: 'red',
              where: 'keyName',
              label: this.translator.instant('keyName dupliquée'),
              value: aExt.keyName,
              uuid: aExt.uuid,
            });
          } else {
            keyNamesForExt.push(aExt.keyName);
          }

          // On doit s'attendre à des params :)
          if (aExt.keyDef !== 'Text' && aExt.keyDef !== 'Date') {
            aExt.params.forEach((aParam) => {
              if (this.hasWhiteSpace(aParam.key)) {
                // result[aExt.uuid].push({
                //   severity: 'red',
                //   where: 'keyNameParam',
                //   label: this.translator.instant('Contient un espace'),
                //   value: aParam.key,
                //   uuid: aExt.uuid,
                // });
              }

              // if (keyNamesForParams.includes(aParam.key)) {
              //   duplicatesKeyNameForParams.push(aParam.key);
              //   result[aExt.uuid].push({
              //     severity: 'yellow',
              //     where: 'keyNameParam',
              //     label: this.translator.instant('keyName dupliquée'),
              //     value: aParam.key,
              //     uuid: aExt.uuid,
              //   });
              // } else {
              //   keyNamesForParams.push(aParam.key);
              // }
            });
          }
        });
        //
        //
        //

        //
        //
        //
        const onlyPbResult = {};
        Object.keys(result).forEach((key) => {
          if (result[key].length > 0) {
            onlyPbResult[key] = result[key];
          }
        });
        resolve(onlyPbResult);
        //
      });
    };

    return from(promiseResult({state, user}));
  }
}

export interface IExtAudit {
  severity: 'red' | 'orange' | 'yellow';
  uuid: string;
  where: string;
  label: string;
  value: string;
}
